import React from 'react';

import MFormFooterView from './MFormFooter.view';

type Props = {
  cancelText?: string;
  removeText?: string;
  confirmText?: string;
  submitAndCreate?: string;
  className?: string;
  disabled?: boolean;
  elementToEnd?: React.ReactNode;
  onCancel?: () => void;
  onRemove?: () => void;
  onSubmitAndReset?: () => void;
};

const MFormFooter: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MFormFooterView
      disabled={props.disabled}
      onRemove={props.onRemove}
      removeText={props.removeText}
      cancelText={props.cancelText}
      confirmText={props.confirmText}
      submitAndCreate={props.submitAndCreate}
      className={props.className}
      onCancel={props.onCancel}
      onSubmitAndReset={props.onSubmitAndReset}
      elementToEnd={props.elementToEnd}
    >
      {props.children}
    </MFormFooterView>
  );
};

MFormFooter.displayName = 'MFormFooter';
MFormFooter.defaultProps = {};

export default MFormFooter;
